import Cookies from 'js-cookie'
// set cookie
export default {
  setCookie (key, value) {
    return Cookies.set(key, value)
  },
  getCookie (key) {
    return Cookies.get(key)
  },
  removeCookie (key) {
    Cookies.remove(key)
  }
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js